import React, {ChangeEvent, CSSProperties, FocusEvent, MouseEvent} from 'react';

interface TextInputProps {
  label?: string;
  name?: string;
  value?: any;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onClick?: (event: MouseEvent<HTMLInputElement>) => void;
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
  error?: string;
  touched?: boolean;
  disabled?: boolean;
  Component?: string;
  maxLength?: number;
  required?: boolean;
  className?: string;
  style?: CSSProperties;
  spacesTrim?: boolean;
  autoComplete?: string;
  isDropdown?: boolean;
}

const TextInput: React.FC<TextInputProps> = ({
  label,
  name,
  value,
  onChange,
  onClick,
  onFocus,
  onBlur,
  error = '',
  touched = false,
  disabled = false,
  Component = '',
  maxLength,
  required = false,
  className = '',
  style = {},
  spacesTrim = false,
  autoComplete = 'off',
  isDropdown = false,
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    let inputValue = event.target.value;

    // If spacesTrim is true, remove spaces
    if (spacesTrim) {
      inputValue = inputValue.replace(/\s+/g, '');
    }

    // Trigger the parent's onChange handler with the updated value
    if (onChange) {
      onChange({
        ...event,
        target: {
          ...event.target,
          value: inputValue,
        },
      });
    }
  };

  return (
    <div className={`mb-0 ${className}`} style={style}>
      <div className='form-floating'>
        {isDropdown && <div style={{position:'relative'}}><span className="material-symbols-outlined mirrorDropdown" style={{fontSize: '24px',position:'absolute',top:'15px',right:'15px',color: "#9f9898"}}>keyboard_arrow_down</span></div>}
        <input
          type='text'
          className={`form-control ${touched && error ? 'is-invalid' : ''}`}
          id={`txt${Component}${name}`}
          name={name}
          value={value}
          onChange={handleChange}
          onClick={onClick}
          onFocus={onFocus}
          onBlur={onBlur}
          placeholder=' '
          disabled={disabled}
          maxLength={maxLength}
          autoComplete={autoComplete}
          // required={required}
        />
        <label htmlFor={`txt${Component}${name}`}>
          {label}
          {!disabled && required && <span style={{color: 'red'}}>*</span>}
        </label>
        {touched && error && <div className='invalid-feedback'>{error}</div>}
      </div>
    </div>
  );
};

export default TextInput;
